import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=80b2323a"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80b2323a')) {
      api.createRecord('80b2323a', component.options)
    } else {
      api.reload('80b2323a', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=80b2323a", function () {
      api.rerender('80b2323a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Authorization/ResetPassword.vue"
export default component.exports